import { FC, PropsWithChildren } from 'react'

import { Footer } from './components/Footer/Footer'
import { Header } from './components/Header/Header'

type TProps = {} & PropsWithChildren

const Layout: FC<TProps> = ({ children }) => {
  return (
    <div
      className="relative flex min-h-full w-full flex-col items-center overflow-hidden bg-palette-black pt-8"
      style={{ minWidth: '1280px' }}
    >
      <div
        className="absolute top-0 flex aspect-square w-full -translate-y-full rounded-half opacity-70"
        style={{
          boxShadow: '0px 0px 720px 0px var(--palette-blue)',
        }}
      />
      <Header />
      <main className="relative flex w-full flex-1 flex-col">{children}</main>
      <Footer />
    </div>
  )
}

export { Layout }
